import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AppService } from './app.service'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthenticationService } from './services';
import { ResponseInterceptor } from './services/app.response.interceptor.service';
import { BlobErrorInterceptor } from './services/app.blobError.interceptor.service';
import { EncrDecrServiceService } from './services/encr-decr-service.service';
import { ConstantConfigService } from './services/constant-config.service';
import { TokenStorageService } from './services/token-storage.service';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import { AuthGuard } from './guards';
import { HttpClientModule, HTTP_INTERCEPTORS,HttpClientXsrfModule } from '@angular/common/http';
import {JwtInterceptor, ErrorInterceptor} from './helpers';
import { DataTablesModule } from 'angular-datatables';
import {SidebarComponent} from './layout/sidebar/sidebar.component';
import {HeaderComponent} from './layout/header/header.component';
import {FooterComponent} from './layout/footer/footer.component';
import {SearchComponent} from './layout/header/search/search.component';
import {LogoComponent} from './layout/header/logo/logo.component';
import {NavigationTriggerComponent} from './layout/header/navigation-trigger/navigation-trigger.component';
import {UserComponent} from './layout/sidebar/user/user.component';
import {PageLoaderComponent} from './layout/page-loader/page-loader.component';

import {Layout1Component} from './layout/layouts/layout-1/layout.component';
import {Layout2Component} from './layout/layouts/layout-2/layout.component';

import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {NgScrollbarModule} from 'ngx-scrollbar';
import { CookieService } from 'ngx-cookie-service';
import { ClipboardModule } from 'ngx-clipboard';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { JwtModule } from "@auth0/angular-jwt";
import { ToastrModule } from 'ngx-toastr';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BnNgIdleService } from 'bn-ng-idle';
import {CustomErrorHandlerService} from './services/custom-error-handler.service';
import { UserIdleModule } from 'angular-user-idle';
import {CurrencyPipe} from '@angular/common';
export function tokenGetter() {
  return localStorage.getItem("access_token");
}


@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    Layout1Component,
    Layout2Component,
    SearchComponent,
    LogoComponent,
    NavigationTriggerComponent,
    UserComponent,
    PageLoaderComponent
    ],
    imports: [
        ClipboardModule,
        BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(), // ToastrModule added
        AppRoutingModule,
        ReactiveFormsModule,
        HttpClientModule,
        DataTablesModule,
        FormsModule,
        NgScrollbarModule,
        BsDropdownModule.forRoot(),
        ButtonsModule.forRoot(),
        MatPasswordStrengthModule,
        ModalModule.forRoot(),
        NgHttpLoaderModule.forRoot(),
        TooltipModule.forRoot(),
        UserIdleModule.forRoot({idle: 1780, timeout: 20, ping: 10}),//{idle: 30, timeout: 40, ping: 10}
        HttpClientXsrfModule.withOptions({
          cookieName: 'XSRF-TOKEN',
          headerName: 'X-XSRF-TOKEN',
        }),
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
                allowedDomains: ["staging.trackmydocs.co"],
                disallowedRoutes: [
                  "staging.trackmydocs.co/services/authenticate",
                  "staging.trackmydocs.co/checkemailexistslogin",
                  "staging.trackmydocs.co/reject_doc_upload",
                  "staging.trackmydocs.co/uploadSamplePdf"
              ]
            }
        })
    ],
  providers: [
    ResponseInterceptor,
    BlobErrorInterceptor,
    AppService,
    AuthGuard,
    AuthenticationService,
    CookieService,
    EncrDecrServiceService,
    TokenStorageService,
    CurrencyPipe,
    BnNgIdleService,
   {
     provide: ErrorHandler,
     useClass: CustomErrorHandlerService
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ResponseInterceptor,
    multi: true
   },
   {
    provide: HTTP_INTERCEPTORS,
    useClass: BlobErrorInterceptor,
    multi: true
   }
  // {
  //   provide: HTTP_INTERCEPTORS,
  //   useClass: JwtInterceptor,
  //   multi: true
  // },
  // {
  //   provide: HTTP_INTERCEPTORS,
  //   useClass: JwtInterceptor,
  //   multi: true
  // },
  // {
  //   provide: HTTP_INTERCEPTORS,
  //   useClass: ErrorInterceptor,
  //   multi: true
  // }
  // ,{
  //   provide: HTTP_INTERCEPTORS,
  //   useClass: CookieService,
  //   multi: true
  //   }
  ],
    bootstrap: [AppComponent]
})
export class AppModule { }
